import type {
    StartRoundResponseType,
    StartRoundRequestType
} from "./type";
import {
    request
} from "../request";

const threeTStartRound = async (args: StartRoundRequestType): Promise<StartRoundResponseType> => {
    return await request<StartRoundResponseType>("/threeT/startRound", {
        body: JSON.stringify(args),
        method: "POST"
    });
};

export default threeTStartRound;
